import { userStore, UINotifications } from "../store";

const hasSeenUiNotification = (notification: keyof UINotifications) =>
  userStore?.user?.settings?.uiNotifications?.[notification]?.seen ?? false;

export default hasSeenUiNotification;
